import {HttpInterceptorFn} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {inject} from '@angular/core';
import Keycloak from 'keycloak-js';

let logoutTriggered = false;

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(Keycloak);

  return next(req).pipe(
    catchError((errorResponse) => {
      if (errorResponse?.status === 401 && !logoutTriggered) {
        logoutTriggered = true;
        void keycloak.logout({
          redirectUri: window.location.origin,
        });
      }

      return throwError(() => errorResponse);
    }),
  );
};
